<!-- Recommended Automations modal - migrated from AngularJS recommendedAutomations-tpl.html -->
<div class="modal-header">
  <h3 class="modal-title">
    Recommended Automations
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise=!minimise"></i>
      <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="form-loader">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="form-content form-row-single-line">
    <div class="form-group col-template">
      <label for="template">Template</label>
      <ap-dropdown class="field-full-width" [list]="templateOptionsForDropdown" [selectType]="'single'"
        inputId="template"
        [title]="'Template'" [hideTitleOnInput]="true" [inputAriaLabel]="'Template'"
        [showSearchbox]="true" [clearSearchKeyword]="true"
        [(ngModel)]="selectedTemplateItem" (onSelect)="onTemplateDropdownSelect($event)">
        @for (item of templateOptionsForDropdown; track $index) {
          <ap-dropdown-list-item #dropdownListItem [item]="item"
            [ariaLabel]="setDropdownAriaLabel(item, 'Template')"
            (onSelectItem)="onTemplateSelectItem($event)"></ap-dropdown-list-item>
        }
      </ap-dropdown>
      @if (templateError) {
<span class="form-error-container">Please Select a Template</span>
}
    </div>

    <div class="form-group col-user">
      <label for="userm1_desc">User M-1 Description</label>
      @if (!isTemplateDisabled()) {
<input
             type="text"
             class="form-control"
             id="userm1_desc"
             [ngModel]="userm1"
             (ngModelChange)="userm1=$event; checkUserDesc()"
             placeholder="">
}
      @if (isTemplateDisabled()) {
<input
             type="text"
             class="form-control"
             id="userm1_desc_ro"
             [ngModel]="userm1"
             readonly
             placeholder="">
}
      @if (userDescError) {
<span class="form-error-container">User M-1 Description is required</span>
}
    </div>

    <div class="form-group col-schdm">
      <label for="schdm_type">SchdM Type</label>
      <div class="dropdown-with-loader" [class.dropdown-loading]="schdmloading">
        <ap-dropdown class="field-full-width" [list]="schdmtypeForDropdown" [selectType]="'single'"
          inputId="schdm_type"
          [title]="'SchdM Type'" [hideTitleOnInput]="true" [inputAriaLabel]="'SchdM Type'"
          [disabled]="isTemplateDisabled()"
          [(ngModel)]="selectedSchdmItem" (onSelect)="onSchdmDropdownSelect($event)">
          @for (item of schdmtypeForDropdown; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'SchdM Type')"
              (onSelectItem)="onSchdmSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
        @if (schdmloading) {
<span class="dropdown-loader"><i class="fa fa-spinner fa-spin"></i></span>
}
      </div>
      @if (typeError) {
<span class="form-error-container">Please Select a SchdM type</span>
}
    </div>

    <div class="form-group col-mult">
      <label for="multiplier">Multiplier</label>
      <input type="text"
             class="form-control"
             id="multiplier"
             [ngModel]="multiplier"
             (ngModelChange)="multiplier=$event; checkMultiplier()"
             placeholder="">
      @if (MultiplierError) {
<span class="form-error-container">Multiplier is required</span>
}
    </div>

    <div class="form-group col-tbbs">
      <label for="tbbs_acct">TBBS Acct</label>
      <div class="dropdown-with-loader" [class.dropdown-loading]="tbbsLoading">
        <ap-dropdown class="field-full-width" [list]="tbbsacctForDropdown" [selectType]="'single'"
          inputId="tbbs_acct"
          [title]="'TBBS Acct'" [hideTitleOnInput]="true" [inputAriaLabel]="'TBBS Acct'"
          [showSearchbox]="true" [clearSearchKeyword]="true"
          [disabled]="isTemplateDisabled()"
          [(ngModel)]="selectedTbbsItem" (onSelect)="onTbbsDropdownSelect($event)">
          @for (item of tbbsacctForDropdown; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'TBBS Acct')"
              (onSelectItem)="onTbbsSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
        @if (tbbsLoading) {
<span class="dropdown-loader"><i class="fa fa-spinner fa-spin"></i></span>
}
      </div>
      @if (tbbsError) {
<span class="form-error-container">Please Select a TBBS acct</span>
}
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button type="button"
          class="save-button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save And Automate
  </button>
  <button type="button" class="reset-button" (click)="reset()">Reset</button>
  <button type="button" class="cancel-button" (click)="cancel()">Cancel</button>
</div>
